"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuburbanCallbackBannerDesktopSuccess = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./style.css"));
var _uiKit = require("@cian/ui-kit");
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SuburbanCallbackBannerDesktopSuccess = _ref => {
  let {
    placeType
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['banner'], style[`banner--success--${placeType}`])
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info-text']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading1, {
    color: "text-inverted-default"
  }, "\u041F\u043E\u0434\u0431\u0438\u0440\u0430\u0435\u043C \u0434\u043B\u044F \u0432\u0430\u0441 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B, ", /*#__PURE__*/React.createElement("br", null), "\u0441\u043A\u043E\u0440\u043E \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u043C"))), /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['image'], style[`image--${placeType}`])
  }));
};
exports.SuburbanCallbackBannerDesktopSuccess = SuburbanCallbackBannerDesktopSuccess;